export default __webpack_public_path__ + "static/media/print.2533ec44.svg";